import StarRating from 'Components/StartsRating'
import styled from 'styled-components'

const UserRating = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding:  ${({ theme }) => theme.responsiveSpacing.medium};
  gap: ${({ theme }) => theme.responsiveSpacing.small};
  max-width: 100%;
`
const UserRatingName = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: start;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: bold;
  color:  ${props => props.theme.colors.text};
  margin: 0;
  
`

const UserRatingText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${props => props.theme.colors.lightText};
  margin-left: ${({ theme }) => theme.responsiveSpacing.small};
  hyphens: auto;

  ::before {
    content: '“';
    margin-left: -0.5em;
    font-size: ${({ theme }) => theme.fontSizes.xLarge};
    position: absolute;
    color: ${props => props.theme.colors.text};
  }
`

const Text = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${props => props.theme.colors.text};
  margin: 10px 0;
`
const Spacer = styled.div<{ height?: string, width?: string }>`
  height: ${props => props.height ?? props.theme.responsiveSpacing.xLarge};
  width: ${props => props.width ?? props.theme.responsiveSpacing.xLarge};
`

interface UserRatingProps {
  ratings: Rating[]
}

interface Rating {
  userName: string
  rating: number
  text: string
}

const UsersRatings: React.FC<UserRatingProps> = ({ ratings }) => {
  return (
    <UserRating>
      {ratings.map((rating, index) => (
        <div key={index}>
          <UserRatingText>
            {rating.text}
          </UserRatingText>
          <Spacer height='5px' />
          <UserRatingName>
            <StarRating />
            <Spacer width='10px' height='0px' />
            <Text> {rating.userName}</Text>
          </UserRatingName>
          <Spacer height='10px' />

        </div>
      ))}
    </UserRating>
  )
}

export default UsersRatings
